import { getFeatures } from 'pricing-pages-lib/api/FeaturesApi';
import { REMOVE_FROM_COMPARE_PRODUCTS, ADD_TO_COMPARE_PRODUCTS, UPDATE_TO_COMPARE_PRODUCTS, ADD_ALL_TO_COMPARE_PRODUCTS } from './constants/ActionTypes';
import { COMPARE } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchCompareRequestTypes = createRequestTypes(COMPARE);
export const FetchFeatureActions = createRequestActions(FetchCompareRequestTypes);
export const fetchCompare = ({
  highlightedProducts
}) => {
  return makeFetchRequest({
    requestActions: FetchFeatureActions,
    fetch: getFeatures,
    payload: {
      highlightedProducts
    }
  });
};
export const addToCompareProducts = payload => dispatch => {
  dispatch({
    type: ADD_TO_COMPARE_PRODUCTS,
    payload
  });
};
export const addAllToCompareProducts = payload => dispatch => {
  dispatch({
    type: ADD_ALL_TO_COMPARE_PRODUCTS,
    payload
  });
};
export const removeFromCompareProducts = payload => dispatch => {
  dispatch({
    type: REMOVE_FROM_COMPARE_PRODUCTS,
    payload
  });
};
export const updateToCompareProducts = payload => dispatch => {
  dispatch({
    type: UPDATE_TO_COMPARE_PRODUCTS,
    payload
  });
};